module.exports = __webpack_public_path__ + "img/image9.8a6b93fc.jpg";